export type OptionType = {
  value: number | string | null;
  text?: string;
  color?: string;
};

export const sentiments: OptionType[] = [
  {
    value: null,
    text: 'none',
    color: 'transparent',
  },
  {
    value: '-2',
    text: '-2',
    color: '#FF5500',
  },
  {
    value: '-1',
    text: '-1',
    color: '#FFBB99',
  },
  {
    value: '0',
    text: '0',
    color: '#E3E5E8',
  },
  {
    value: '1',
    text: '1',
    color: '#A3BEF5',
  },
  {
    value: '2',
    text: '2',
    color: '#1656E9',
  },
  {
    value: '99',
    text: '99',
    color: '#FFFFFF',
  },
];

export const findSentimentColor = (sentimentValue: string | null) =>
  sentiments.find((option: OptionType) => option.value === sentimentValue)
    ?.color;
